export default {
	site_name: 'nds',
};
